export default {"src":"/_next/static/media/refer_a_friend.22aad7cc.svg","height":110,"width":161,"blurWidth":0,"blurHeight":0};